import {initHash} from "./hash";
import {initResize} from "./resize";
import {initScroll} from "./scroll";
import {initForms} from "./form";
import {initGridHelpBlock} from "./grid";

export const initCommon = () => {
	initHash();
	initResize();
	initScroll();
	initForms();
	initGridHelpBlock();
};
